import * as requestFromServer from "./couponCodesApis";
import Actions from "../../actions";
import { routes } from "../../../constants";
import { toastService } from "../../../component/common/toast-messages/toast";
import { baseRouteMakerForSuperAdmin } from "../../../constants/routeConsts";

// coupons -> get coupons select list api
export const getCouponCodesAction = (dataToBeSent, setLoading) => async (dispatch) => {
      setLoading(true);
      const response = await requestFromServer.getCouponCodes(dataToBeSent);
      if (response) {
        dispatch(Actions.createAction(Actions.GET_COUPON_CODES_LIST, {couponCodes: response}));
        setLoading(false);
        return response;
      }
      else {
        setLoading(false)
        return null;
      }
  };


  // coupons -> create coupon api
export const createCouponCodeAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.createCouponCode(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    navigate(baseRouteMakerForSuperAdmin(routes.COUPON_CODES));
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};


// coupons -> get coupons code by id api
export const getCouponCodeByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getCouponCodeById(dataToBeSent);
  if (response) {
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};


// coupons -> update coupons api
export const updateCouponCodeAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.updateCouponCode(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    setLoading(false);
    navigate(baseRouteMakerForSuperAdmin(routes.COUPON_CODES));
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};


// coupons -> delete coupons by id api
export const deleteCouponCodeByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.deleteCouponCodeById(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};